import { preBootMobileApp } from "./app-startup"
import { createApp } from "vue"
import { registerPlugins } from "@/plugins"
import App from "./App.vue"
import { useAlertStore } from "@/store/alert.store"
import { AlertTypes } from "@/interfaces/component/alert.interface"
import { isProductionEnvironment } from "@/helper/app/browser-helper"
import { Capacitor } from "@capacitor/core"
import { AuthController } from "@/controllers/auth-controller"

// PNTS-12313: impersonation columns are never persisted, so tokens left from before a reload are orphans.
AuthController.clearOrphanedImpersonationTokens()

const app = createApp(App)

if (Capacitor.isNativePlatform()) {
  preBootMobileApp()
}

app.config.errorHandler = (err, vm, info) => {
  if (!isProductionEnvironment()) {
    const alertStore = useAlertStore()
    alertStore.addAlert({
      type: AlertTypes.ERROR,
      title: "Applicatiefout",
      body: `${err} | Component: ${vm?.$options?.name} | Additional info: ${info}`,
      lifetime: 5000
    })
  }
  console.error(err, vm, info)
}

// Plugins
registerPlugins(app)
